import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import { classnames } from 'tailwindcss-classnames';
import { Field, LinkField } from '@sitecore-jss/sitecore-jss-react';
import useDictionary from 'lib/sitecore/use-dictionary';
import ShowMoreListing from 'components/helpers/ShowMoreListing';
import { Routes } from '.generated/templates/Project.Routes.model';
import { Data } from '.generated/templates/Feature.Data.model';
import Container from 'components/helpers/Container';
import LinkA11yWrapper from 'components/helpers/LinkA11yWrapper';

export type GenericPage = Sitecore.Override.ItemEx & Routes.Fields.GenericPage;
export type NavigationLink = Sitecore.Override.ItemEx & Data.Navigation.Fields.NavigationLink;
export type pageorLink = GenericPage | NavigationLink;

type LinkItemProps = pageorLink;

export type ManualLinkListProps = Sitecore.Override.ComponentBase &
  Components.Navigation.ManualLinkList.Fields.ManualLinkList & {
    fields: {
      linkList?: pageorLink[];
    };
  };

const LinkItem = ({ fields, displayName, url }: LinkItemProps): JSX.Element => {
  if (!fields) {
    return <></>;
  }

  const navitem = fields.navigationItemLink ? (fields.navigationItemLink as NavigationLink) : null;
  const pageTitle: Field<string> = fields.pageTitle as Field<string>;
  const linkfield = navitem
    ? (fields.navigationItemLink as LinkField)
    : {
        value: {
          href: url,
          text: pageTitle.value ? pageTitle.value : displayName,
        },
      };

  return (
    <>
      <div className={classnames('inline-block')}>
        <LinkA11yWrapper
          className={classnames(
            'font-semibold',
            'text-theme-btn-link-text',
            'text-base',
            'leading-3',
            'sm:text-body',
            'hover:text-theme-btn-link-text-hover',
            'hover:underline'
          )}
          editable={false}
          field={linkfield}
        />
      </div>
    </>
  );
};

const ManualLinkList = ({ fields }: ManualLinkListProps): JSX.Element => {
  const dictionary = useDictionary();
  if (!fields) {
    return <MissingDataSource />;
  }

  const seeAllCtaText = dictionary.See_All_ManualLinkList;
  const seeLessCtaText = dictionary.See_Less_ManualLinkList;

  const headingProps = propsFromFields(fields);

  return (
    <Container size="standard" dataComponent="authorable/navigation/manuallinklist">
      <div className={fields?.description.value ? classnames('mb-4') : ''}>
        <Heading {...headingProps} className={classnames('mb-4')} />
      </div>
      <ShowMoreListing
        items={fields.linkList}
        maxInitialDisplay={fields.maxInitialDisplay.value}
        seeAllCtaClassName={classnames('mt-6')}
        seeAllCtaText={seeAllCtaText}
        seeLessCtaText={seeLessCtaText}
        component={LinkItem}
      />
    </Container>
  );
};

export default ManualLinkList;
